import type { UserDto } from "./user.dto";
import type { LoginDto } from "./login.dto";
import type { RegisterDto } from "./register.dto";
import type { UpdateUserDto } from "./update-user.dto";
import type { ResetPasswordDto } from "./reset-password.dto";
import type { UpdatePasswordDto } from "./update-password.dto";
import type { ForgotPasswordDto } from "./forgot-password.dto";

import { api } from "../core/api";

export async function login(dto: LoginDto): Promise<UserDto> {
  localStorage.removeItem("token") // clears any previous token

  const { data, headers } = await api.post("/api/v1/login", { user: dto });
  const user: UserDto = data;
  localStorage.setItem("token", headers["authorization"]);
  localStorage.setItem("user", user.id);
  return user;
}

export async function register(dto: RegisterDto): Promise<UserDto> {
  const { data, headers } = await api.post("/api/v1/signup", { user: dto });
  const user: UserDto = data;
  localStorage.setItem("token", headers["authorization"]);
  localStorage.setItem("user", user.id);
  return user;
}

export async function getUser(): Promise<UserDto> {
  const hasToken = !!localStorage.getItem("token");
  if (!hasToken) throw new Error("É necessário estar autenticado!");

  const { data } = await api.get<UserDto>("/api/v1/users");
  return data;
}

export async function updateUser(dto: UpdateUserDto): Promise<UserDto> {
  const { data } = await api.patch<UserDto>("/api/v1/users", { user: dto });
  return data;
}

export async function updateAvatar(file: File): Promise<UserDto> {
  const body = new FormData();
  body.append("user[avatar]", file);
  const { data } = await api.patchForm<UserDto>("/api/v1/users", body);
  return data;
}

export async function updatePassword(data: UpdatePasswordDto) {
  const response = await api.patch("/api/v1/users/update_password", {
    user: {
      current_password: data.current_password,
      password: data.new_password,
      password_confirmation: data.new_password_confirmation,
    },
  });
  return response.data;
}

export async function forgotPassword(dto: ForgotPasswordDto) {
  await api.post("/api/v1/password", { user: dto });
}

export async function resetPassword(dto: ResetPasswordDto) {
  await api.patch("/api/v1/password", { user: dto });
}

export function logout() {
  localStorage.removeItem("token");
}
